// extracted by mini-css-extract-plugin
module.exports = {"clearFilter":"UserFilter_clearFilter_1b1gD","divider":"UserFilter_divider_hPgdM","spinAround":"UserFilter_spinAround_1MQFv"};